import { Instagram, MapPin, Mail } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_b4nk-studio/artifacts/ob8a8fa3_logo.jpeg";

const goTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-black border-t border-white/10 overflow-hidden"
        >
            {/* Massive watermark text */}
            <div className="relative px-6 md:px-10 pt-20 pb-6 max-w-7xl mx-auto">
                <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
                    {/* Brand */}
                    <div className="lg:max-w-md">
                        <div className="flex items-center gap-3">
                            <img
                                src={LOGO}
                                alt="TATZBYB4NK"
                                className="w-14 h-14 object-cover border border-[#7CFC00]/40"
                            />
                            <div className="font-display text-3xl text-white tracking-wider">
                                TATZ<span className="text-[#7CFC00]">BY</span>B4NK
                            </div>
                        </div>
                        <p className="mt-5 text-zinc-400 leading-relaxed">
                            Custom tattoos out of Dallas / Plano, TX. Built one clean line at a time. Every piece
                            drawn for the person wearing it.
                        </p>
                        <a
                            data-testid="footer-ig-link"
                            href="https://instagram.com/tatzbyb4nk"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-6 inline-flex items-center gap-2 text-[#7CFC00] uppercase tracking-widest text-sm font-bold border-b border-transparent hover:border-[#7CFC00] pb-1"
                        >
                            <Instagram size={16} />
                            @tatzbyb4nk
                        </a>
                    </div>

                    {/* Links */}
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 flex-1">
                        <div>
                            <div className="text-xs uppercase tracking-[0.3em] text-[#7CFC00] mb-4 font-semibold">
                                Explore
                            </div>
                            <ul className="space-y-2">
                                {[
                                    { id: "portfolio", l: "Portfolio" },
                                    { id: "about", l: "Artist" },
                                    { id: "services", l: "Pricing" },
                                    { id: "reviews", l: "Reviews" },
                                ].map((x) => (
                                    <li key={x.id}>
                                        <button
                                            data-testid={`footer-link-${x.id}`}
                                            onClick={() => goTo(x.id)}
                                            className="text-zinc-300 hover:text-[#7CFC00] transition-colors text-sm"
                                        >
                                            {x.l}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div>
                            <div className="text-xs uppercase tracking-[0.3em] text-[#7CFC00] mb-4 font-semibold">
                                Booking
                            </div>
                            <ul className="space-y-2">
                                <li>
                                    <button
                                        data-testid="footer-link-book"
                                        onClick={() => goTo("booking")}
                                        className="text-zinc-300 hover:text-[#7CFC00] text-sm"
                                    >
                                        Book Session
                                    </button>
                                </li>
                                <li>
                                    <a
                                        data-testid="footer-link-booksy"
                                        href="https://booksy.com/en-us/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-zinc-300 hover:text-[#7CFC00] text-sm"
                                    >
                                        Booksy
                                    </a>
                                </li>
                                <li>
                                    <a
                                        data-testid="footer-link-ig"
                                        href="https://instagram.com/tatzbyb4nk"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-zinc-300 hover:text-[#7CFC00] text-sm"
                                    >
                                        Instagram DM
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div>
                            <div className="text-xs uppercase tracking-[0.3em] text-[#7CFC00] mb-4 font-semibold">
                                Find Us
                            </div>
                            <ul className="space-y-3">
                                <li className="flex items-start gap-2 text-zinc-300 text-sm">
                                    <MapPin size={16} className="text-[#7CFC00] mt-0.5" />
                                    <span>
                                        Dallas / Plano
                                        <br />
                                        Texas, USA
                                    </span>
                                </li>
                                <li className="flex items-start gap-2 text-zinc-300 text-sm">
                                    <Mail size={16} className="text-[#7CFC00] mt-0.5" />
                                    <span>book@tatzbyb4nk.com</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Massive logo text */}
            <div className="relative overflow-hidden border-t border-white/10">
                <div className="font-display text-[28vw] md:text-[20vw] leading-[0.85] text-center text-transparent stencil-stroke select-none whitespace-nowrap py-4">
                    TATZBYB4NK
                </div>
            </div>

            <div className="border-t border-white/10 px-6 md:px-10 py-6 max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
                <div className="text-zinc-500 text-xs uppercase tracking-widest">
                    © {new Date().getFullYear()} TATZBYB4NK · All ink reserved
                </div>
                <div className="text-zinc-600 text-xs uppercase tracking-widest">
                    Built In Dallas · Worn Worldwide
                </div>
            </div>
        </footer>
    );
};
